import { render } from "./PropertyCard.vue?vue&type=template&id=312f05ae&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"

import "./PropertyCard.vue?vue&type=style&index=0&id=312f05ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312f05ae"]])

export default __exports__